import React from 'react'
import { ActivityIndicator, StyleSheet } from 'react-native'
import Animated, { FadeInDown } from 'react-native-reanimated'

import { DS } from '@/design-system'

import * as d10 from '@/router/(root)/daily10/d10Module'
import { D10AdminControls as AdminControls } from "@/components/Mini/AdminControls"
import { D10Background as Background } from "@/components/Mini/Background"
import { D10Header as Header } from "@/components/Mini/Header"
import { D10Rules as Rules } from "@/components/Mini/Rules"
import { D10StatBlocks as StatBlocks } from "@/components/Mini/StatBlocks"
import { D10Footer as Footer } from "@/components/Mini/EntryScreenFooter"
import { SecondaryBtn} from "@/components/Mini/Button"

import type { MinigameModule } from '@/types/minigameModule'


export function Daily10EntryScreen() {

  const { status } = d10.useD10QueryStatus() //use for loading

  const { isAdmin, isSuperAdmin } = d10.useD10User()
  
  const gameName = d10.useStore(s => s.GAME_NAME)
  const handleClose = d10.useHandleClose()

  const error = d10.useStore((state) => state.error)
  //const isStartingGame = d10.useStore((state) => state.isStartingGame) //todo, handle potential flash

  /*admin*/
  const showAdminControls = isAdmin || isSuperAdmin

  return (
    <Background>
        <Header title={gameName} handler={handleClose} />
          
            {showAdminControls && <AdminControls />}

            <Animated.View entering={FadeInDown.springify()} style={styles.body}>
                      
              <Rules />

              {/* error appears beneath rules if game cannot be created when user clicks play*/}
              {error && (
                <DS.Text variant="Body Large/Regular" style={styles.error}>
                  {error}
                </DS.Text>
              )}
                      
              <StatBlocks />
                      
              <LeaderboardBtn m={d10}/>
                      
            </Animated.View>

            <Footer />

    </Background>
  )
}


function LeaderboardBtn({ m }: { m: MinigameModule }) {

  const handleLeaderboard = m.useHandleLeaderboard()
  const theme = m.useStore(s => s.theme)

  return (
    <SecondaryBtn theme={theme} handler={handleLeaderboard} label="Leaderboard" />
  )
}


const styles = StyleSheet.create({
  fill: { flex: 1 },
  body: { flex: 1, paddingHorizontal: 24, justifyContent: 'center', gap: 40 },
  
  container: {
    flex: 1,
    //backgroundColor: DS.palette['Brand/Cream']
  },
  scrollContent: {
    flexGrow: 1,
    paddingBottom: 24
  },
  content: {
    paddingHorizontal: 16
  },
  error: {
    color: DS.palette['Utility/Warning'],
    textAlign: 'center'
  }
})
